import React from 'react'
import { TailSpin } from 'react-loader-spinner'
import { useAppSelector } from '@/app/hooks'

interface LoadingProps {
  loading: boolean
  size?: number
}

export const LoadingFull: React.FC<LoadingProps> = ({ loading, size }) => {
  const design = useAppSelector(state => state.design)
  if (loading) {
    return (
      <div
        css={[
          {
            position: 'fixed',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: design?.background.backgroundColor || '#ffffff',
            opacity: 0.8,
            zIndex: 10000,
          },
        ]}
      >
        <TailSpin
          color={design?.icon.color}
          wrapperStyle={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
          width={size || 60}
          height={size || 60}
        />
      </div>
    )
  }

  return <></>
}
